"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateTechniqueAttr = void 0;
const Expr_1 = require("./Expr");
const PropertyValue_1 = require("./PropertyValue");
function evaluateTechniqueAttr(context, attrValue, defaultValue) {
    if (attrValue === undefined) {
        return defaultValue;
    }
    const result = Expr_1.Env.isEnv(context)
        ? PropertyValue_1.getPropertyValue(attrValue, context)
        : PropertyValue_1.getPropertyValue(attrValue, context.env, context.cachedExprResults);
    return result !== null && result !== void 0 ? result : defaultValue;
}
exports.evaluateTechniqueAttr = evaluateTechniqueAttr;
//# sourceMappingURL=TechniqueAttr.js.map